/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./style.scss";
import { CustomInput } from "src/Components";
import { Button } from "src/Components/customInput";

import { ReactComponent as Add } from "src/Assets/Icons/add.svg";
import { ReactComponent as Search } from "src/Assets/Icons/search.svg";
import { ReactComponent as Erase } from "src/Assets/Icons/erase.svg";

import { isValid } from "../services/utils";
import { GetApi } from "../services/auth";
import showToast from "../services/toastyService";
import { data } from "react-router-dom";

const BASE_DATA = window.globalConfig?.BASE_DATA || {};

export default function Relatorio({ darkMode }) {
  const [bancos, setBancos] = useState([]);
  const [movimentacoes, setMovimentacoes] = useState([]);

  const [relatorioInfo, setRelatorioInfo] = useState({
    Exportador: "",
    Moeda: "",
    Banco: "",
  });
  const [showResultado, setShowResultado] = useState({});

  function formatarMoeda(moeda) {
    switch (moeda) {
      case "USD":
        return "Dólar (USD)";
      case "EUR":
        return "Euro (EUR)";
      default:
        return "Real (BRL)";
    }
  }

  function formatarValor(valor, moeda = "BRL") {
    if (valor == null || isNaN(valor)) {
      switch (moeda) {
        case "USD":
          return "US$ 0,00";
        case "EUR":
          return "€ 0,00";
        default:
          return "R$ 0,00";
      }
    }

    switch (moeda) {
      case "USD":
        return valor.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        });
      case "EUR":
        return valor.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
        });
      default:
        return valor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        });
    }
  }

  function calcularRelatorio() {
    if (
      !isValid(relatorioInfo.Exportador) ||
      !isValid(relatorioInfo.Moeda) ||
      !isValid(relatorioInfo.Banco)
    ) {
      return;
    }

    const credito = movimentacoes
      .filter(
        (m) =>
          m.Modalidade === "Aproveitamento" &&
          m.Exportador === relatorioInfo.Exportador &&
          Number(m.Banco_id) === Number(relatorioInfo.Banco),
      )
      .reduce((t, m) => t + (m.Cambio_Contratado || 0), 0);

    const debito = movimentacoes
      .filter((m) => {
        const matchModalidade = m.Modalidade === "ACC";
        const matchExportador = m.Exportador === relatorioInfo.Exportador;

        const matchBanco = Number(m.Banco_id) === Number(relatorioInfo.Banco);

        const isMatch = matchModalidade && matchExportador && matchBanco;

        return isMatch;
      })
      .reduce((t, m) => t + (m.Cambio_Contratado || 0), 0);

    const debitoBase = getBaseBancoValor(
      relatorioInfo.Exportador,
      relatorioInfo.Moeda,
      relatorioInfo.Banco,
    );

    setShowResultado({
      Exportador: relatorioInfo.Exportador,
      Moeda: formatarMoeda(relatorioInfo.Moeda),
      Banco: relatorioInfo.Banco,
      Credito: credito,
      Debito: debito + debitoBase,
    });

    //console.log(debito + " / " + debitoBase);
  }

  useEffect(() => {
    if (!isValid(bancos)) {
      GetApi("bancos")
        .then((res) => {
          setBancos(res?.data?.bancos || []);
        })
        .catch((error) => {
          showToast("error", error);
        });
    }

    if (!isValid(movimentacoes)) {
      GetApi("cambios")
        .then((res) => {
          setMovimentacoes(res?.data?.cambios);
          showToast("success", res.message);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  function getBaseBancoValor(exportador, moeda, bancoId) {
    const key =
      exportador === "Nicchio Café Ltda"
        ? "nicchio"
        : exportador === "Vix Café Ltda"
          ? "vixport"
          : null;

    if (!key) return 0;

    const bancosBase = BASE_DATA?.[key]?.[moeda]?.Bancos || [];

    const banco = bancosBase.find((b) => b.banco_id === Number(bancoId));

    return banco?.debito || 0;
  }

  return (
    <div className="Relatorio">
      <div className="-popup">
        <div className="relatorioContent">
          <aside>
            <h3> Relatório de Movimentações </h3>
            <CustomInput
              Style="Default"
              Type="select"
              Placeholder="Exportador"
              OnChange={(e) =>
                setRelatorioInfo((prev) => ({
                  ...prev,
                  Exportador: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Exportador</option>
              <option value="Nicchio Café Ltda">Nicchio Café</option>
              <option value="Vix Café Ltda">Vixport</option>
            </CustomInput>
            <CustomInput
              Style="Default"
              Type="select"
              Placeholder="Moeda"
              OnChange={(e) =>
                setRelatorioInfo((prev) => ({
                  ...prev,
                  Moeda: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Moeda</option>
              <option value="USD">Dólar</option>
              <option value="EUR">Euro</option>
            </CustomInput>
            <CustomInput
              Style="Default"
              Type="select"
              Placeholder="Banco"
              OnChange={(e) =>
                setRelatorioInfo((prev) => ({
                  ...prev,
                  Banco: e.target.value,
                }))
              }
            >
              <option value="">Selecionar Banco</option>
              {bancos &&
                bancos.map((item, index) => (
                  <option value={item?.Banco_id}>{item?.Nome}</option>
                ))}
            </CustomInput>

            <span>
              <Button ClassName="icon" OnClick={() => setShowResultado({})}>
                <Erase /> Limpar
              </Button>

              <Button ClassName="icon" OnClick={() => calcularRelatorio()}>
                <Search /> Ver Relatório
              </Button>
            </span>
          </aside>
          <aside className={isValid(showResultado) ? "active" : "notActive"}>
            <h3> Saldo do Relatório </h3>
            <p>
              Exportador: <b>{showResultado.Exportador}</b>
            </p>
            <p>
              Moeda: <b>{showResultado.Moeda}</b>
            </p>
            <p>
              Banco: <b>{showResultado.Banco}</b>
            </p>
            <hr />
            <p className="result">
              <span>Crédito:</span>
              {formatarValor(showResultado.Credito, showResultado.Moeda)}
            </p>
            <p className="result">
              <span>Débito:</span>
              {formatarValor(showResultado.Debito, showResultado.Moeda)}
            </p>
            <p className="result">
              <span>Saldo:</span>
              {formatarValor(
                showResultado.Credito - showResultado.Debito,
                showResultado.Moeda,
              )}
            </p>
          </aside>
        </div>
      </div>
    </div>
  );
}
